import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './styles/fonts.css'
import './styles/base.css'
import { setupTelegram } from './telegram'

setupTelegram()

const root = document.getElementById('root')
if (!root) throw new Error('нет корневого элемента')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
